import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { Icon } from "../icon";
import { Blank } from "../icon/svg";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
export function Result(_a) {
    var _b;
    var className = _a.className, children = _a.children, scene = _a.scene, icon = _a.icon, title = _a.title, description = _a.description, footer = _a.footer, footerFixed = _a.footerFixed, props = __rest(_a, ["className", "children", "scene", "icon", "title", "description", "footer", "footerFixed"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-result", className) }, props),
        React.createElement(ResultHeader, { scene: scene, icon: icon }),
        React.createElement(View, { className: classPrefix + "-result__body" },
            title && (React.createElement(View, { className: classPrefix + "-result__title" }, title)),
            description && (React.createElement(View, { className: classPrefix + "-result__description" }, description)),
            children),
        React.createElement(View, { className: classNames(classPrefix + "-result__footer", (_b = {},
                _b[classPrefix + "-result__footer--fixed"] = footerFixed,
                _b)) }, footer)));
}
var sceneMap = {
    blank: React.createElement(Icon, { size: TaroEnv ? 120 : 60, name: Blank }),
    success: React.createElement(Icon, { size: TaroEnv ? 120 : 60, name: "success", color: "#29CC85" }),
    error: React.createElement(Icon, { size: TaroEnv ? 120 : 60, name: "warning", color: "#FF584C" }),
    pending: React.createElement(Icon, { size: TaroEnv ? 120 : 60, name: "pending", color: "#006EFF" }),
};
function ResultHeader(_a) {
    var scene = _a.scene, icon = _a.icon;
    var classPrefix = useConfig().classPrefix;
    var children = sceneMap[scene];
    if (!children) {
        children = icon;
        if (typeof icon === "string") {
            if (icon.includes("/")) {
                children = React.createElement(Icon, { size: TaroEnv ? 400 : 200, name: icon });
            }
            else {
                children = React.createElement(Icon, { size: TaroEnv ? 120 : 60, name: icon });
            }
        }
    }
    return React.createElement(View, { className: classPrefix + "-result__header" }, children);
}
//# sourceMappingURL=Result.js.map